import axiosHttp from "./interceptor.service";

const postProject = (data) => {
  return axiosHttp.post("/lmt/createProject", data);
};

const getProject = ({
  sort,
  limit,
  page,
  search,
  isEnabled,
  clientId,
  employeeId,
  ProjectLeadId,
} = {}) => {
  return axiosHttp.get("/lmt/getProject", {
    params: { sort, limit, page, search, isEnabled, clientId, employeeId, ProjectLeadId },
  });
};

const updateProject = (id, data) => {
  return axiosHttp.put(`/lmt/updateProject/${id}`, data);
};

const deleteProject = (id, data) => {
  return axiosHttp.delete(`/lmt/deleteProject/${id}`, data);
};

const getProjectTypes = (query = {}) => {
  return axiosHttp.get("/lmt/getProjectTypes", { params: query });
};

export { postProject, getProject, updateProject, deleteProject, getProjectTypes };
